import { Fragment, type ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { twMerge } from 'tailwind-merge';

import Backdrop from './Backdrop';

export interface ModalProps {
  children?: ReactNode;
  customStyle?: string;
  width?: string;
}
const ModalOverlay = ({ children, customStyle, width }: ModalProps) => {
  return (
    <div
      className={twMerge([
        'fixed h-5/6 md:h-4/5 lg:h-auto lg:max-h-full overflow-y-scroll',
        'no-scrollbar top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
        'max-w-lg w-11/12 md:w-1/2 bg-white p-6 rounded-md shadow-md z-100 transition duration-300 ease-out',
        width,
        customStyle,
      ])}
    >
      <div>{children}</div>
    </div>
  );
};

const portalElement = document.getElementById('overlays')!;

const Modal = ({ children, customStyle, width }: ModalProps) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay customStyle={customStyle} width={width}>
          {children}
        </ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default Modal;
